// extracted by mini-css-extract-plugin
export var circle = "_gw-1";
export var exitConfirmationModal = "_gw-5";
export var iframe = "_gw-0";
export var offline = "_gw-3";
export var online = "_gw-2";
export var workstationSelectError = "_gw-4";